module.exports = __webpack_public_path__ + "static/boxmodel28-5b539864146be4f01d42f8acd22db8ca.png";